import { render, staticRenderFns } from "./rcd-collection-list.vue?vue&type=template&id=2386ac85&"
import script from "./rcd-collection-list.vue?vue&type=script&lang=js&"
export * from "./rcd-collection-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports